module.exports = __webpack_public_path__ + "img/Quizz_0004_cinto-seg.28dff512.png";